module.exports = __webpack_public_path__ + "img/temp_google.53adb39e.png";